// Cannot import AppState as it imports this
// import BlockTemplatesMenu from "./blockTemplatesMenu";
import BlockTemplatesHeader from "./blockTemplatesHeader";
import BlockTemplatesParallax from "./blockTemplatesParallax";
import BlockTemplatesFeatures from "./blockTemplatesFeatures";
import BlockTemplatesInfo from "./blockTemplatesInfo";

export default [
  // NAVIGATION MENU
  /* {
    id: 10,
    type: "nav",
    title: "Navigation Menu",
    templates: BlockTemplatesMenu
  }, */
  // HEADERS
  {
    id: 20,
    type: "header",
    title: "Headers",
    templates: BlockTemplatesHeader
  },
  // PARALLAX ********************
  {
    id: 30,
    type: "parallax",
    title: "Parallax",
    templates: BlockTemplatesParallax
  },
  // FEATURES ********************
  {
    id: 40,
    type: "features",
    title: "Features",
    templates: BlockTemplatesFeatures
  },
  // INFO ********************
  {
    id: 50,
    type: "info",
    title: "Info",
    templates: BlockTemplatesInfo
  }
];



// WEBPACK FOOTER //
// ./src/util/blockTemplates.js